import { VHeaders } from '@/models/pagedlistmodel';

export function getDepartmentListHeaders(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t('departments.departmentGridHeaders.name') as string,
      align: 'left',
      value: 'name',
      sortable: true,
    },
    {
      text: vm.$parent.$t(
        'departments.departmentGridHeaders.description'
      ) as string,
      align: 'left',
      value: 'description',
      sortable: false,
    },
    {
      text: vm.$parent.$t('departments.departmentGridHeaders.action') as string,
      isNotDataProp: true,
      align: 'center',
      sortable: false,
    },
  ];
}
export function getManagerListHeaders(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t('departments.managerGridHeaders.manager') as string,
      align: 'left',
      value: 'email',
    },
    {
      text: vm.$parent.$t(
        'departments.managerGridHeaders.amountLimt'
      ) as string,
      align: 'left',
      value: 'approvalLimit',
    },
    {
      text: vm.$parent.$t('departments.managerGridHeaders.action') as string,
      isNotDataProp: true,
      align: 'center',
      sortable: false,
    },
  ];
}
